export { SpaceMainPage as default } from "@nvb/ui";
